export const ssoClientId = "487040ad-706c-4a22-89d0-9723fa1adc3b";
// export const clientId = "9eed0fa7-33c9-4b5e-8449-8004d1f0a5c2";
